import { XCircle } from "@untitledui/icons";
import { ModalOverlay, Modal, Dialog } from "@/components/application/modals/modal";
import { Button } from "@/components/base/buttons/button";
import { useTranslation } from "react-i18next";

interface SignOutConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const SignOutConfirmModal = ({ isOpen, onClose, onConfirm }: SignOutConfirmModalProps) => {
    const { t } = useTranslation('common');

    return (
        <ModalOverlay isOpen={isOpen} onOpenChange={(open) => !open && onClose()}>
            <Modal>
                <Dialog>
                    <div className="rounded-xl bg-primary p-6 shadow-lg ring-1 ring-secondary">
                        <div className="flex items-center justify-between mb-6">
                            <h2 className="text-xl font-semibold text-primary">
                                {t('signOut.confirm.title')}
                            </h2>
                            <button
                                onClick={onClose}
                                className="text-tertiary hover:text-primary"
                                aria-label={t('buttons.close')}
                            >
                                <XCircle className="size-5" />
                            </button>
                        </div>
                        <p className="text-tertiary mb-6">
                            {t('signOut.confirm.message')}
                        </p>
                        <div className="flex justify-end gap-3">
                            <Button onClick={onClose} color="secondary" size="md">
                                {t('buttons.cancel')}
                            </Button>
                            <Button onClick={onConfirm} color="primary-destructive" size="md">
                                {t('buttons.logout')}
                            </Button>
                        </div>
                    </div>
                </Dialog>
            </Modal>
        </ModalOverlay>
    );
};

